// extracted by mini-css-extract-plugin
export default {"commentsHeader":"Header_commentsHeader__66vhw","backButton":"Header_backButton__h1U7k"};